import { TablePaginationConfig } from 'antd'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import TanksPageHeader from '@/components/pages/Tanks/List/PageHeader'
import TanksTable from '@/components/pages/Tanks/List/Table'
import routes from '@/constants/routes'
import { Detergent } from '@/types'

import { useTanks } from './Tank.hooks'

const Tanks = () => {
  const navigate = useNavigate()

  const { filterToQuery, page, pageSize, getTanks, getTanksLoading, getTanksResponse, deleteTank } = useTanks()

  const totalItems = getTanksResponse?.meta.totalItems || 0

  const handleDeleteTank = async (id: Detergent['id']) => {
    await deleteTank({ id })
    getTanks()
  }

  const handleChangePage = (config: TablePaginationConfig) => {
    navigate({
      pathname: routes.tanks.path,
      search: filterToQuery({
        page: config.current ?? page,
      }),
    })
  }

  useEffect(() => {
    getTanks()
  }, [getTanks])

  return (
    <>
      <TanksPageHeader />
      <TanksTable
        {...{
          dataSource: getTanksResponse?.items,
          getTanksLoading,
          page,
          pageSize,
          totalItems,
        }}
        onDelete={handleDeleteTank}
        onChange={handleChangePage}
      />
    </>
  )
}

Tanks.displayName = 'Tanks'
export default Tanks
